import React, { useState, useEffect, useContext } from "react";
import { getCurrentDate } from "../../../configs/helpers";
import { ReviewOrderPurchaseList } from "../fragments.buys/ReviewOrderPurchaseList";

import { useParams } from "react-router";
import { fetchedOrderPurchaseByID } from "../../../apis/apis.logistics/apisProduct";
import { initialOrderState } from "../../../configs/OrderPurchaseStates";

export function ReviewOrderPurchasePage() {
    let { id } = useParams();
    const [order, setOrder] = useState(initialOrderState);
    const getOrderPurchase = async () => {
        try {
            const response = await fetchedOrderPurchaseByID({
                operationID: id,
            });
            setOrder(response);
        } catch (error) {
            throw error;
        }
    };

    useEffect(() => {
        getOrderPurchase();
    }, []);

    return (
        <>
            <section className="mb-6">
                <div className="max-w-full px-4">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <h1 className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">
                            ORDENES DE COMPRA: RECEPCION REALIZADA
                        </h1>
                        <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                            <span>Orden de Compras</span>
                            <span className="text-gray-400">/</span>
                            <span className="font-medium text-gray-900 dark:text-white">{id}</span>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="max-w-full px-4">
                    <ReviewOrderPurchaseList
                        order={order}
                        setOrder={setOrder}
                        initialOrderState={initialOrderState}
                    />
                </div>
            </section>
        </>
    );
}
